import {
  TehnicalInspection,
  TehnicalInspectionEditFormValues,
  TehnicalInspectionRow,
} from "./types";

/*---------------------------------------------------------------------------------------
  CALCULATION TEHNICAL INSPECTION 
-----------------------------------------------------------------------------------------*/

export const transformTehnicalInspection = (
  res: any
): TehnicalInspection => {
  return {
    id: res.id,
    vehicleGroupId: res.vehicleGroup.id,
    vehicleGroupName: res.vehicleGroup.name,
    price: res.price,
  };
};

/*---------------------------------------------------------------------------------------
  CALCULATION TEHNICAL INSPECTION SEARCH
-----------------------------------------------------------------------------------------*/

export const transformTehnicalInspectionRow = (
  res: any
): TehnicalInspectionRow => {
  return {
    id: res.id,
    vehicleGroupId: res.vehicleGroup.id,
    vehicleGroupName: res.vehicleGroup.name,
    price: res.price,
  };
};

/*---------------------------------------------------------------------------------------
    CALCULATION TEHNICAL INSPECTION CREATE
  -----------------------------------------------------------------------------------------*/

export const transformTehnicalInspectionOnCreate = (
  formValues: TehnicalInspectionEditFormValues
): any => ({
  vehicleGroupId: formValues.vehicleGroupId,
  price: formValues.price,
});

/*---------------------------------------------------------------------------------------
  CALCULATION TEHNICAL INSPECTION EDIT
-----------------------------------------------------------------------------------------*/

export const transformTehnicalInspectionOnUpdate = (
  formValues: TehnicalInspectionEditFormValues
): any => ({
  id: formValues.id,
  vehicleGroupId: formValues.vehicleGroupId,
  price: formValues.price,
});


